import type {ReactElement} from 'react'
import {useSafeEffectExtraDeps} from '@freckle/react-hooks'
import type {AuthStatus} from '@freckle/classroom/ts/store/auth'
import {useAuthStore} from '@freckle/classroom/ts/store/auth'

type Props = {
  render: (authState: AuthStatus) => ReactElement
}

export function WithAuthStatus(props: Props) {
  const {checkAuthStatus, authStatus} = useAuthStore()
  const {render} = props

  useSafeEffectExtraDeps<{checkAuthStatus: () => Promise<void>}>(
    ({checkAuthStatus}) => {
      checkAuthStatus()
    },
    [],
    {checkAuthStatus: {value: checkAuthStatus, comparator: () => true}},
  )

  return authStatus.hasCheckedAuth ? render(authStatus) : <></>
}
